import type React from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Chip,
  IconButton,
} from "@mui/material";
import { Person as PersonIcon, Edit as EditIcon } from "@mui/icons-material";

interface NicknameEditorProps {
  nickname: string;
  isEditing: boolean;
  tempNickname: string;
  onStartEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onTempNicknameChange: (value: string) => void;
}

export const NicknameEditor: React.FC<NicknameEditorProps> = ({
  nickname,
  isEditing,
  tempNickname,
  onStartEdit,
  onSave,
  onCancel,
  onTempNicknameChange,
}) => {
  return (
    <Box sx={{ p: 2, bgcolor: "grey.50" }}>
      {isEditing ? (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <TextField
            size="small"
            value={tempNickname}
            onChange={(e) => onTempNicknameChange(e.target.value)}
            placeholder="Tu nombre"
            variant="outlined"
            sx={{ flexGrow: 1 }}
          />
          <Button size="small" onClick={onSave}>
            Guardar
          </Button>
          <Button size="small" onClick={onCancel}>
            Cancelar
          </Button>
        </Box>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Hablando como:
          </Typography>
          <Chip
            label={nickname || "Usuario Anónimo"}
            size="small"
            icon={<PersonIcon />}
            onClick={onStartEdit}
            clickable
          />
          <IconButton size="small" onClick={onStartEdit}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
